import { supabase } from "../../lib/supabase/client";

// Login User
export const login = async (submittedData: {
	email: string;
	password: string;
}) => {
	const { email, password } = submittedData;

	const res = await supabase.auth.signInWithPassword({
		email: email,
		password: password,
	});

	if (!res.error) {
		localStorage.setItem("tra_accessToken", res.data.session.access_token);
	}

	return res;
};

const authService = {
	login,
};

export default authService;
